import { Injectable, signal, computed } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Environment } from '../../interfaces/store-configuration.interface';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {
  readonly baseUrl = environment.baseUrl;
  readonly backendBaseUrl = environment.backendBaseUrl;

  private _environment = signal<Environment | null>(null);
  readonly environment = this._environment.asReadonly();

  // Add initialization state
  private _isInitialized = signal(false);
  readonly isInitialized = this._isInitialized.asReadonly();

  // Computed signal for filtered environment
  readonly environmentFiltered = computed(() => {
    const env = this._environment();
    return env || null;
  });

  // Computed signal to check if environment is ready

  constructor() {
    this.initializeEnvironment();
  }

  private initializeEnvironment(): void {
  }

  updateEnvironment(env: Environment) {

    // Use signal update for reactive state change
    this._environment.set(env);
    this._isInitialized.set(true);

  }

  // Keep setEnvironment for backward compatibility but mark as deprecated
  /** @deprecated Use updateEnvironment instead */
  setEnvironment(env: Environment) {
    this.updateEnvironment(env);
  }

  get environmentValue(): Environment {
    const env = this._environment();
    if (!env) {
      throw new Error('Environment not initialized');
    }
    return env;
  }

  clearEnvironment() {
    this._environment.set(null);
    this._isInitialized.set(false);
  }

}
